import { useMemoizedFn } from 'ahooks';
import { Languages, setLanguage, updateTranslations } from 'locales';
import { EnumLanguageCode } from 'models/language';
import { useTranslation } from 'react-i18next';
import uploadTask from 'services/uploadTask';
import { arrayToNestedObject } from 'utils';

const useLanguage = () => {
  const { i18n } = useTranslation();
  const changeLanguage = useMemoizedFn(async (lang: Languages) => {
    i18n.changeLanguage(lang);
    setLanguage(lang);
    const map = {
      [Languages.CN]: EnumLanguageCode.zh_CN,
      [Languages.EN]: EnumLanguageCode.en_US,
      [Languages.HK]: EnumLanguageCode.zh_TW
    };
    const res = await uploadTask.queryI18n(map[lang]);
    console.log('language res: ', res);
    if (Array.isArray(res.data) && res.data.length) {
      const i18Value = arrayToNestedObject(res.data);
      updateTranslations(i18Value);
    }
  });

  return {
    changeLanguage: changeLanguage
  };
};

export default useLanguage;
